// extracted by mini-css-extract-plugin
export var productImage = "_o1-1";
export var viewLink = "_o1-2";
export var wishlistItem = "_o1-0";